// Reference:
// * https://github.com/epicweb-dev/epic-stack/blob/51648518380bef7045d9e5b4b20ff5b621a21ff6/app/utils/request-info.ts

import { invariant } from "@epic-web/invariant";
import { useRouteLoaderData } from "react-router";

import { type loader as rootLoader } from "@/root";

// Get requestInfo from the root loader.
//
export function useRequestInfo() {
  // @ts-expect-error known prerelease issue of react-router v7
  const data = useRouteLoaderData<typeof rootLoader>("root");
  invariant(data?.requestInfo, "No requestInfo found in root loader");

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return data.requestInfo;
}
